













import {defineComponent} from "@vue/composition-api"

export default defineComponent({
    name: "OnboardingModal",
    props: {
        contentClass: {
            type: String,
            required: false
        }
    }
})
